import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { get } from "lodash";
import { DetailTable, Detail } from "MODULES/shared/components/DetailTable";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import Section from "MODULES/shared/components/Section";
import { INVENTORY } from "MODULES/inventories/constants";
import { percent } from "LIB/formatters/number";
import {
  CONSIGNMENT_REFERENCE_COMPANY,
  CONSIGNOR_PERCENTAGE,
  CONSIGNMENT_REFERENCE,
  CONSIGNMENT,
  CONSIGNMENT_REFERENCE_COMPANY_ID
} from "MODULES/Receiving/constants";
import { CompanyName } from "MODULES/shared/components";
import { translateProps } from "MODULES/shared/decorators";
import { decorators } from "@orange-marmalade/paginate-this";

export function Consignment({ loading, results }) {
  if (loading) return null;
  const lineItem = results[0];
  if (!lineItem) return null;
  const company = {
    id: get(lineItem, [INVENTORY, CONSIGNMENT_REFERENCE_COMPANY_ID].join(".")),
    name: get(
      lineItem,
      [INVENTORY, CONSIGNMENT_REFERENCE_COMPANY, "name"].join(".")
    ),
    company_type: null
  };

  if (
    get(lineItem, [INVENTORY, "consignment_type"].join(".")) !== CONSIGNMENT
  ) {
    return null;
  }

  return [
    <hr />,
    <Section title="Consignment" editable={false}>
      <DetailTable>
        <Detail
          label="Consignment Ref. Co"
          value={<CompanyName company={company} />}
        />
        <Detail
          label="Consignment Ref #"
          value={get(lineItem, [INVENTORY, CONSIGNMENT_REFERENCE].join("."))}
        />
        <Detail
          label="Consignment Split"
          value={percent(
            get(lineItem, [INVENTORY, CONSIGNOR_PERCENTAGE].join(".")),
            100
          )}
        />
      </DetailTable>
    </Section>
  ];
}

Consignment.propTypes = {
  salesOrder: T.instanceOf(Map).isRequired,
  ...WithCurrentUser
};

const withListId = translateProps(() => ({
  listId: "salesOrders/lineItems"
}));

export default withCurrentUser(withListId(decorators.tabulate(Consignment)));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/Consignment/Consignment.jsx